/*
 * Project: bellcloud
 * File: packages/utils/device/commonValidation.ts
 * Author: SWAN
 * Created: 2025-01-27
 * Description: 공통 검증 로직
 */

// Removed unused import: SensorType, SENSOR_TYPE_INFO

interface ValidationResult {
  isValid: boolean;
  error?: string;
  warning?: string;
  isEnglish?: boolean;
  suggestedValue?: number;
}

export function validateWorkerName(value: string, maxBytes: number = 16): ValidationResult {
  // Check byte length (UTF-8 encoding)
  const byteLength = new TextEncoder().encode(value).length;
  if (byteLength > maxBytes) {
    return {
      isValid: false,
      error: 'error_workerNameLength',
    };
  }

  // Allow all languages (Unicode letters), numbers (0-9), '-', '_'
  const validPattern = /^[\p{L}0-9\-_]*$/u;
  if (!validPattern.test(value)) {
    return {
      isValid: false,
      error: 'error_workerNameInvalid',
    };
  }

  // Check if only English characters are used
  const englishPattern = /^[a-zA-Z0-9\-_]*$/;
  const isEnglish = englishPattern.test(value);

  // Add warning if not English (warning key for UI translation)
  const warning = !isEnglish ? 'warning_nonEnglishWorkerName' : undefined;

  return { isValid: true, isEnglish, warning };
}

export function validateLocationName(value: string, maxBytes: number = 16): ValidationResult {
  // Check byte length (UTF-8 encoding)
  const byteLength = new TextEncoder().encode(value).length;
  if (byteLength > maxBytes) {
    return {
      isValid: false,
      error: 'error_locationNameLength',
    };
  }

  // Allow all languages (Unicode letters), numbers (0-9), '-', '_'
  const validPattern = /^[\p{L}0-9\-_]*$/u;
  if (!validPattern.test(value)) {
    return {
      isValid: false,
      error: 'error_locationNameInvalid',
    };
  }

  // Check if only English characters are used
  const englishPattern = /^[a-zA-Z0-9\-_]*$/;
  const isEnglish = englishPattern.test(value);

  // Add warning if not English (warning key for UI translation)
  const warning = !isEnglish ? 'warning_nonEnglishLocationName' : undefined;

  return { isValid: true, isEnglish, warning };
}

// Time interval validation
export function validateTimeInterval(value: number, min: number, max: number): ValidationResult {
  // Check for null, undefined, or NaN
  if (value === null || value === undefined || isNaN(value)) {
    return {
      isValid: false,
      error: 'error_valueRequired',
    };
  }

  // Check for zero or negative values (if min is positive)
  if (min > 0 && value <= 0) {
    return {
      isValid: false,
      error: 'error_invalidRange',
    };
  }

  // Check range
  if (value < min || value > max) {
    return {
      isValid: false,
      error: 'error_invalidRange',
    };
  }
  return { isValid: true };
}
